<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/tokenizer_example.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("tokn.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Das ist ein erster Satz. Wenn z. B. im zweiten Satz eine Abkürzung wie ca. steht, ist das kein ProblemWenn die camel-calse Option aktiviert ist, werden Satzenden automatisch eingefügt.", "split_camel_case": true}
                    </p>

                    <h4 class="font-weight--light">{{ $t("tokn.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"sentences": ["Das ist ein erster Satz.", "Wenn z. B. im zweiten Satz eine Abkürzung wie ca. steht, ist das kein Problem.", "Wenn die camel-calse Option aktiviert ist, werden Satzenden automatisch eingefügt."]}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
